import React from "react";
import logoImage from "../assets/new_persona_logo.svg";
import "../styles/components/LandingScreen.css";

const LandingScreen: React.FC = () => {
  return (
    <div className="landing-container">
      <div className="landing-content">
        <img src={logoImage} alt="Persona" className="persona-logo" />
      </div>
    </div>
  );
};

export default LandingScreen;
